var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloude(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1470_762)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 64,
    height: 64,
    rx: 12,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 62,
    height: 62,
    rx: 11,
    stroke: "#373737",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8535 41.6001L32.7196 37.1865L32.8519 36.8032L32.7196 36.59H32.3363L31.0217 36.509L26.5272 36.3875L22.6292 36.2255L18.8527 36.0231L17.9025 35.8206L17.0117 34.6464L17.1035 34.0606L17.9025 33.5234L19.0471 33.6233L21.5764 33.7961L25.3718 34.0579L28.1252 34.2199L32.2041 34.6437H32.8519L32.9437 34.3818L32.7223 34.2199L32.5496 34.0579L28.6219 31.3963L24.3703 28.5835L22.1433 26.9638L20.9394 26.1432L20.332 25.3739L20.0702 23.6948L21.1634 22.4909L22.6319 22.5908L23.0071 22.6906L24.4945 23.8352L27.6717 26.2944L31.8207 29.3501L32.4281 29.8549L32.6711 29.6821L32.7007 29.5607L32.4281 29.1045L30.1714 25.0256L27.7635 20.8766L26.6918 19.1571L26.4084 18.1259C26.3085 17.7021 26.2356 17.3458 26.2356 16.9112L27.4801 15.2214L28.1684 15L29.8286 15.2214L30.5277 15.8287L31.5589 18.188L33.2298 21.9024L35.8213 26.953L36.5798 28.4512L36.9847 29.8387L37.1359 30.2625H37.3977V30.0196L37.611 27.1744L38.0051 23.6813L38.3884 19.1868L38.5207 17.9208L39.147 16.4037L40.3914 15.5831L41.3632 16.0474L42.1622 17.1919L42.0515 17.9316L41.5764 21.0197L40.6451 25.8571L40.0378 29.0964H40.3914L40.7963 28.6915L42.4349 26.5157L45.1883 23.074L46.403 21.7081L47.8202 20.1991L48.7299 19.481H50.4494L51.7155 21.3625L51.1486 23.3061L49.3778 25.552L47.9093 27.4551L45.8037 30.2895L44.4891 32.557L44.6106 32.7379L44.9237 32.7082L49.6801 31.6959L52.2499 31.2316L55.3165 30.7052L56.704 31.3531L56.8552 32.0117L56.3099 33.3588L53.0301 34.1686L49.1834 34.9379L43.4552 36.293L43.3851 36.3443L43.466 36.4442L46.0467 36.6871L47.1507 36.7465H49.8529L54.8846 37.1217L56.1992 37.991L56.9874 39.0545L56.8552 39.8644L54.8306 40.8955L52.0988 40.2477L45.7227 38.7306L43.5362 38.1853H43.2339V38.3662L45.056 40.1478L48.3952 43.163L52.5766 47.0502L52.7898 48.0112L52.2526 48.7697L51.6858 48.6888L48.0119 45.9246L46.5947 44.6801L43.3851 41.978H43.1718V42.2614L43.9114 43.3439L47.8175 49.2151L48.02 51.0157L47.7365 51.6014L46.7242 51.9551L45.6121 51.7526L43.3257 48.543L40.9664 44.9285L39.0633 41.6892L38.8311 41.8214L37.7082 53.9175L37.1818 54.5357L35.967 55L34.9548 54.2307L34.4176 52.9862L34.9548 50.5271L35.6026 47.3175L36.129 44.7665L36.6041 41.5974L36.8875 40.5446L36.8687 40.4744L36.6365 40.5041L34.2475 43.7839L30.6141 48.6942L27.7392 51.7715L27.0509 52.0441L25.8577 51.426L25.9684 50.3219L26.6352 49.3393L30.6141 44.2779L33.0139 41.1412L34.5633 39.3299L34.5525 39.068H34.4608L23.8925 45.9299L22.011 46.1729L21.2012 45.4144L21.3011 44.1699L21.6844 43.765L24.8616 41.5785L24.8508 41.5893L24.8535 41.6001Z",
    fill: "#D97757"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1470_762",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1470_762"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.308333 0 0 0 0 0.308333 0 0 0 0 0.308333 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1470_762"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1470_762",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloude);
export default __webpack_public_path__ + "static/media/cloude.aa2c15fb313cce398a00e5bdcb263a00.svg";
export { ForwardRef as ReactComponent };